import { StorageService } from '@flyblack/common/services';

export const storage = new StorageService('flyblack-admin');
